import { t } from 'i18next';
import { getRoleIconForSpec } from '../../../../../../shared/common/wow';
import { CharacterRosterName } from './characterRosterName';
import { Col } from '../../../../../../shared/frontend/components/grid/Col';
import { Row } from '../../../../../../shared/frontend/components/grid/Row';

type TVantusTooltipContentProps = {
  roster: any[];
};

export function VantusTooltipContent(props: TVantusTooltipContentProps) {
  const membersWithVantus = props.roster.filter((r: any) => r.vantus);
  if (membersWithVantus.length === props.roster.length) {
    return (
      <div>
        <div className="text-bold text-underline">{t('encounter-details:vantus.vantus-runes-on')}</div>
        {t('encounter-details:vantus.entire-raid')}
      </div>
    );
  }

  const rolesWithVantus = membersWithVantus.reduce(
    (accum: Record<string, number>, item: any) => {
      const icon = getRoleIconForSpec(item.character.spec);
      accum[icon]++;
      return accum;
    },
    {
      tank: 0,
      healer: 0,
      'dps-melee': 0,
      'dps-ranged': 0
    }
  );

  return (
    <div>
      <div className="text-bold text-underline">{t('encounter-details:vantus.vantus-runes-on')}</div>
      <Row align="center" verticalAlign="center" className="slds-m-bottom--x-small">
        <Col size={8}>
          {(Object.entries(rolesWithVantus) as [string, number][]).map(
            ([roleIcon, count]) =>
              count > 0 && (
                <span className="slds-m-horizontal--xx-small">
                  <span
                    className={`icon-role icon-x-small ${roleIcon} slds-avatar slds-p-horizontal--x-small slds-m-right--xx-small`}
                  />
                  <b>{count}</b>
                </span>
              )
          )}
        </Col>
      </Row>
      <div style={{ maxWidth: 300 }}>
        <Row wrap verticalAlign="center" align="center">
          {membersWithVantus
            .sort((a: any, b: any) => a.character.name.localeCompare(b.character.name))
            .map((r: any) => (
              <Col>
                <CharacterRosterName character={r.character} />
              </Col>
            ))}
        </Row>
      </div>
    </div>
  );
}
